import VueRouter from 'vue-router';
import rawRoutes from '@user/router/routes';
import { buildRoutes } from '@user/router/buildRoutes';

export const createRouter = (
  projectParam = '',
  extensions = [],
  exclude = []
) => {
  const routes = buildRoutes(projectParam, rawRoutes, extensions, exclude);
  return new VueRouter({
    mode: 'history',
    routes,
  });
};
